// toolbar.js

import { DraggableNode } from "./draggableNode";

export const PipelineToolbar = () => {
  return (
    <div
      style={{
        padding: "12px",
        backgroundColor: "#f8f9fa",
        borderBottom: "1px solid #e9ecef",
        boxShadow: "0 4px 12px rgba(12, 12, 12, 0.25)",
      }}
    >
      <div
        style={{
          marginBottom: "16px",
          padding: "10px 14px",
          borderLeft: "4px solid #764ba2",
          background: "rgba(118, 75, 162, 0.08)",
          borderRadius: "6px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "16px",
            fontWeight: "600",
            color: "#000",
            letterSpacing: "0.4px",
          }}
        >
          Add Nodes
        </h3>
      </div>
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        {/* Core Nodes */}
        <DraggableNode type="customInput" label="Input" />
        <DraggableNode type="customOutput" label="Output" />
        <DraggableNode type="text" label="Text" />
        <DraggableNode type="llm" label="LLM" />

        {/* Processing Nodes */}
        <DraggableNode type="filter" label="Filter" />
        <DraggableNode type="splitter" label="Splitter" />
        <DraggableNode type="join" label="Join" />
        <DraggableNode type="calculator" label="Calculator" />
        <DraggableNode type="conditional" label="Conditional" />
      </div>
    </div>
  );
};
